import React from "react";
import {
  Button,
  Link,
  TextInput,
  DisabledInput,
  SaveButton,
  DateInput,
  Create,
  Toolbar,
  SelectInput,
  Edit,
  SimpleForm
} from "react-admin";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { parse } from "query-string";
import moment from "moment";
const priceTypes = [
  { _id: "tour_total", desc: "tour_total", description: "Base Price" },
  { _id: "tour_passenger", desc: "tour_passenger", description: "Passenger" },
  { _id: "tour_single", desc: "tour_single", description: "Single Room" },
  { _id: "tour_base_model", desc: "tour_base_model", description: "Base Model" },
  { _id: "tour_vehicle", desc: "tour_vehicle", description: "Tour Vehicle" },
  { _id: "tour_cat_2", desc: "tour_cat_2", description: "Cat 2" },
  { _id: "tour_cat_4", desc: "tour_cat_4", description: "Cat 4" },
  { _id: "tour_cat_6", desc: "tour_cat_6", description: "Cat 6" },
  { _id: "tour_cat_8", desc: "tour_cat_8", description: "Cat 8" },
  { _id: "tour_cat_10", desc: "tour_cat_10", description: "Cat 10" },
  { _id: "tour_cat_12", desc: "tour_cat_12", description: "Cat 12" },
  { _id: "tour_cat_14", desc: "tour_cat_14", description: "Cat 14" },
  // { _id: "tour_f700_up", desc: "tour_f700_up", description: "F700" },
  // { _id: "tour_f_up", desc: "tour_f_up", description: "F Upgrade" },
  // { _id: "tour_st_up", desc: "tour_st_up", description: "ST Upgrade" },
  // { _id: "tour_gs_up", desc: "tour_gs_up", description: "GS Upgrade" },
  // { _id: "tour_rt_up", desc: "tour_rt_up", description: "RT Upgrade" },
  // { _id: "tour_gt_up", desc: "tour_gt_up", description: "GT Upgrade" },
  // { _id: "tour_gsa_up", desc: "tour_gsa_up", description: "GSA Upgrade" },
  // { _id: "tour_f6_up", desc: "tour_f6_up", description: "F6 Upgrade (OLD - Not mandatory)"},
];

const EditPriceTourTitle = () => <span>Edit Price for Tour</span>;

const CreatePriceTourTitle = () => <span>Create Tour Price</span>;

const CancelButton = _props => {
  return (
    <Button
      component={Link}
      to={{
        pathname: `${_props.redirectTo}`
      }}
      label="Cancel"
    >
      <ArrowBackIcon />
    </Button>
  );
};

const TourPriceToolbar = props => (
  <Toolbar {...props}>
    <SaveButton label="Save" submitOnEnter={true} />
    <CancelButton redirectTo={props.redirect} />

    {/* <Button
          component={Link}
          to={{
            pathname: `/tour_prices/${props.record.price_item_id}`
          }}
          label="Back to Tour Prices">
          <ArrowBackIcon />
      </Button> */}
  </Toolbar>
);

function Fecha(date){
  return moment.utc(date).locale('es').format('YYYY-MM-DD');
}

export const PricetCreate = props => {
  const tour_id = parse(props.location.search).price_item_id;
  const redirect = tour_id ? `/tour_prices/${tour_id}` : "edit";
  return (
    <Create title={<CreatePriceTourTitle />} {...props}>
      <SimpleForm redirect={redirect} toolbar={<TourPriceToolbar />}>
        <DisabledInput source="price_item_id" visibility="{hidden}" />
        <DisabledInput source="price_item_type" />
        <TextInput source="price" label="Price" />
        <DateInput source="start_date" label="Start Date" locales="es-Es" options={{ timeZone: 'UTC' }} format={Fecha}/>
        <SelectInput
          source="price_item_sub_type"
          choices={priceTypes}
          optionText="description"
          optionValue="_id"
        />
      </SimpleForm>
    </Create>
  );
};

export const PricetEdit = props => {
  const tour_id = parse(props.location.search).tour_id;
  const redirect = tour_id ? `/tour_prices/${tour_id}` : "edit";
  return (
    <Edit title={<EditPriceTourTitle />} {...props}>
      <SimpleForm redirect={redirect} toolbar={<TourPriceToolbar />}>
        <TextInput source="price" label="Price" />
        <DateInput source="start_date" label="Start Date" locales="es-Es" options={{ timeZone: 'UTC' }} format={Fecha} />
        <SelectInput
          source="price_item_sub_type"
          choices={priceTypes}
          optionText="description"
          optionValue="_id"
        />
      </SimpleForm>
    </Edit>
  );
};



// WEBPACK FOOTER //
// ./src/resources/pricest.js